import { render, staticRenderFns } from "./CheckResource.vue?vue&type=template&id=22d463a2&scoped=true&"
import script from "./CheckResource.vue?vue&type=script&lang=js&"
export * from "./CheckResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d463a2",
  null
  
)

export default component.exports